'use client';

import { createFileRoute, redirect } from '@tanstack/react-router';
import { getVerifyPermission } from '@repo/shared/helpers';
import { PERMISSIONS } from '@repo/shared/domain';
import { getAuthenticatedSession } from 'src/api/authentication';
import { getGroup } from 'src/api/admin/groups';

export const Route = createFileRoute('/_admin/groups/$groupId/')({
	loader: async ({ params }) => {
		const group = await getGroup(params.groupId);

		if (group?.type?.Form) {
			throw redirect({ to: '/groups/$groupId/details', params: { groupId: params.groupId } });
		}

		const session = await getAuthenticatedSession();
		const verifyPermission = getVerifyPermission(session?.user?.permissions || []);

		if (verifyPermission(PERMISSIONS.adminUsersView)) {
			throw redirect({ to: '/groups/$groupId/users', params: { groupId: params.groupId } });
		}

		throw redirect({ to: '/groups/$groupId/contact-details', params: { groupId: params.groupId } });
	},
	component: () => null,
});
